/** Single schema bucket for non-OASIS RogerDoc visits (matches backend `NON_OASIS_MERGED_SECTION_NAME`, currently `All`). */
export const NON_OASIS_WHOLE_VISIT_SECTION_NAME = 'All' as const;
